module.exports = __webpack_public_path__ + "media/fastweb_college_scholarships_app/app-landing-page-1-b36f9d09.png";